<script lang="ts">
  export let contents: string;
  export let centered = false;
  let clazz = "text-medium";
  export { clazz as class };
  export let style = "";
</script>

{#if centered}
  <div style="display: flex; flex-direction: row; align-items: center">
    <p class={clazz} {style}>{contents}</p>
  </div>
{:else}
  <p class={clazz} {style}>{contents}</p>
{/if}
